import React from "react";

const PlaceholderBody = ({ children }) => (
  <div className="content-placeholder__body">{children}</div>
);

PlaceholderBody.displayName = "ContentPlaceholder.Body";

export default PlaceholderBody;
